import { ListItem } from 'types/TextSearch';
import { colors, screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import noResults from 'public/static/images/srp/NoResults.svg';
import classNames from 'classnames';
import DropdownItem from './DropdownItem';

interface DropdownProps {
  hide: boolean;
  className?: string;
  listItems: ListItem[];
  queryText: string;
  cursor: number | null;
  onClick: (item: ListItem) => void;
}

export default function Dropdown({
  hide,
  className,
  listItems,
  queryText,
  cursor,
  onClick,
}: DropdownProps): JSX.Element | null {
  const { t } = useTranslation();

  if (hide) {
    return null;
  }

  return (
    <>
      <div
        className={classNames('dropdown-container', className)}
        aria-label="text-search-dropdown"
      >
        <div className="dropdown-content">
          <ul className="text-search-dropdown-list">
            {listItems.length === 0 ? (
              <li className="no-results">
                <div className="no-results-logo-container">
                  <div className="no-results-logo" />
                </div>
                <div>{t('commonlyUsed.noResults')}</div>
              </li>
            ) : (
              listItems.map((listItem, i) => (
                <DropdownItem
                  key={i}
                  item={listItem}
                  active={cursor === i}
                  triggerSearch={onClick}
                />
              ))
            )}
          </ul>
        </div>
      </div>
      <style jsx>{`
        .hide {
          display: none;
        }

        .dropdown-container {
          display: ${queryText === '' ? 'none' : 'block'};
          height: 378px;
          max-height: 378px;
          max-width: 682px;
          width: calc(100% + 2px);
          position: absolute;
          z-index: 12;
          background: ${colors.WHITE};
          border: 1px solid ${colors.G2};
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 5px 10px ${colors.G2};
        }

        .modal-dropdown {
          position: static;
          height: 100%;
          max-height: 100%;
          width: 100%;
        }

        .dropdown-content {
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          height: 100%;
        }

        .text-search-dropdown-list {
          padding: 0;
          margin: 0;
        }

        .no-results {
          padding: 5px 16px 5px 16px;
          width: 100%;
          text-align: left;
          font-weight: 400;
          font-size: 16px;
          color: black;
          display: flex;
          align-items: center;
        }

        .no-results-logo-container {
          display: flex;
          align-items: center;
          width: 50px;
          height: 50px;
          justify-content: center;
          margin-right: 8px;
        }

        @media (min-width: ${screen.smMin}) {
          .no-results-logo-container {
            justify-content: left;
            margin-right: 0;
          }
        }

        .no-results-logo {
          background: none;
          background-image: url(${noResults});
          background-size: contain;
          background-repeat: no-repeat;
          height: 24px;
          width: 24px;
        }
      `}</style>
    </>
  );
}
